













import Vue from 'vue';
import FormField from './FormField.vue';
import customerVuex from '../../../vuex/common';

interface Sex {
  label: string;
  value: number;
}

const sexes: Sex[] = [
  { label: '所有', value: -1 },
  { label: '男', value: 1 },
  { label: '女', value: 2 },
];

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
  },
  data() {
    return {
      sexes,
    };
  },
  methods: {
    updateSex(value: number) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'sex',
        value,
      });
    },
  },
});
